import { useMutation } from '@tanstack/react-query';
import axios, { AxiosResponse } from 'axios';
import API_URL from '../constants/environment';

interface OrganizationResponse {
    organization: {
        _id: string;
        name: string;
        organizationMode?: 'full-time' | 'invoicing' | 'inventory';
    };
    locations: Array<{
        _id: string;
        title: string;
    }>;
}

export const findOrganization = async (inputAccessCode: string): Promise<OrganizationResponse> => {
    const { data }: AxiosResponse<OrganizationResponse> = await axios.post(
        `${API_URL}/organization/find`,
        { inputAccessCode }
    );
    return data;
};


export const useFindOrganization = () => {
    return useMutation({
        mutationFn: findOrganization,
    });
};